<template>
  <ImageHeader :headerTitle="'FAQ'" :imageSource="require('../assets/leeb-images3/pic1.jpg')">
    <v-card elevation="0">
      <v-card-title>Häufig gestellte Fragen</v-card-title>
      <v-card-text>
        Hier finden Sie Antworten auf Ihre Fragen.
      </v-card-text>
    </v-card>
    <v-card elevation="0">
      <v-card-title>
        Allgemeine Fragen zu unseren Produkten
      </v-card-title>
      <v-card-text>
        <v-expansion-panels accordion>
          <v-expansion-panel v-for="faqEntry in faqContent.filter(x => x.question !== '')" :key="faqEntry.question">
            <v-expansion-panel-header>{{ faqEntry.question }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ faqEntry.answer }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </ImageHeader>
</template>

<script>
import ImageHeader from '../components/ImageHeader.vue'

export default {
  name: 'Faq',
  components: {
    ImageHeader
  },
  data() {
    return {
      faqContent: [
        {
          question: 'Welche Vorteile haben Leeb-Produkte aus Aluminium?',
          answer: 'Aluminium weist als Leichtmetall eine hohe Korrosionsbeständigkeit auf. Daher ist es ideal geeignet für den Bau von Balkonen und Zäunen. Eine klare Linienführung, stabile Eckrahmenkonstruktion, Softline-Kanten und die innovative Pulverbeschichtung ALU COMFORT PLUS® machen alle Leeb Produkte aus Aluminium nahezu pflege- und wartungsfrei. Die vielfältige Alu-Gestaltungsvarianten lassen kaum Wünsche nach Individualität offen.'
        },
        {
          question: 'Wie werden Leeb-Produkte beschichtet und witterungsbeständig gemacht?',
          answer: 'Alle Leeb-Aluprodukte sind mit dem patentierten ALU COMFORT PLUS® beschichtet. Dadurch werden sie witterungsbeständiger und kratzfester – und somit einfacher in der Wartung. Denn im Gegensatz zu nachträglich aufgebrachter Konservierung sind die Wirkstoffe hier im kompletten Lackaufbau verteilt und werden somit nicht durch Bewitterung abgebaut.'
        },
        {
          question: 'Gibt es Aluminiumprodukte in Holzoptik?',
          answer: 'Leeb Alu- und Glasbalkone, Aluminium-Zäune und Alu-Böden sind in 10 verschiedenen Holzstrukturen erhältlich: Lärche, Kirsche, Kiefer hell, Kiefer dunkel, Kastanie, Greywood, Goldeiche, Eiche, Douglasie und Esche.'
        },
        {
          question: 'In welchen Farben gibt es Leeb-Balkone und Zäune?',
          answer: 'Leeb-Balkone und Zäune erhalten ihre Farbe in der hauseigenen Beschichtungsanlage. Es stehen über 200 verschiedene RAL-Farben zur Auswahl.Wenn Sie die Vorzüge eines Alubalkons oder Aluzauns genießen und gleichzeitig aber nicht auf den Holzlook verzichten möchten, bietet Leeb 10 verschiedene, täuschend echte Holzstrukturen an.'
        },
        {
          question: 'Was versteht man unter RAL-Farben?',
          answer: 'Als RAL-Farben bezeichnet man normierte Farben, die die RAL GmbH vertreibt. Der Farbkatalog besteht aus 213 Farbtönen, welche jeweils mit einer vierstelligen Nummer gekennzeichnet sind. Leeb Balkone, Zäune und Überdachungen sind in allen RAL-Farben erhältlich!'
        },
        {
          question: 'Sind Sonderkonstruktionen möglich?',
          answer: 'Sie haben ganz bestimmte Vorstellungen oder möchten gerne aus mehreren Modellen kombinieren? Kein Problem, bei Leeb gehen wir auf Ihre individuellen Wünsche ein. Bitte kontaktieren Sie Ihren zuständigen LEEB-Berater, der Ihnen gerne weiterhilft.'
        },
        {
          question: 'Wie finde ich das für meinen Stil passende Balkon- oder Zaunmodell?',
          answer: 'Unsere Leeb-Partner stehen Ihnen gerne für eine unverbindliche und individuelle Vor-Ort-Beratung zur Verfügung. Mit dem Leeb-3D-Konfigurator suchen Sie bequem vor Ort Ihr Wunschmodell aus und können in einer 3D-Ansicht Ihres Eigenheims unterschiedliche Modelle und Farbkombinationen ausprobieren.'
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        {
          question: '',
          answer: ''
        },
        
      ]
    }
  },
}
</script>
